
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.268 21c.303 0 .628-.11.867-.354a1.246 1.246 0 000-1.747l-8.21-8.403 8.21-8.381a1.246 1.246 0 000-1.747A1.205 1.205 0 009.423.346L.347 9.61a1.231 1.231 0 00-.347.885c0 .332.13.641.347.884l9.076 9.266c.239.243.542.354.845.354z","fill":"#FFF","fill-rule":"nonzero"}})])
          )
        }
      }
    